var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile-hide shadow-1", attrs: { color: "white" } },
    [
      _c("div", { staticClass: "row q-py-md q-px-md fit justify-center" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-2" }, [
              _c("img", {
                staticStyle: { "max-width": "100%", "max-height": "50px" },
                attrs: { src: _vm.logo, height: "auto" }
              })
            ]),
            _c(
              "div",
              { staticClass: "col-10 text-right self-center" },
              [
                _c("q-btn", {
                  attrs: {
                    flat: "",
                    dense: "",
                    size: "lg",
                    color:
                      "admin_overview" === _vm.$route.name
                        ? "primary"
                        : "secondary",
                    label: _vm.$t("overview")
                  },
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ name: "admin_overview" })
                    }
                  }
                }),
                _vm.showUsers ||
                _vm.showOrganization ||
                _vm.showTags ||
                _vm.showImport
                  ? _c(
                      "q-btn-dropdown",
                      {
                        attrs: {
                          flat: "",
                          dense: "",
                          size: "lg",
                          label: _vm.$t("records"),
                          color: _vm.getColorRegistrations()
                        }
                      },
                      [
                        _c(
                          "q-list",
                          { attrs: { link: "" } },
                          [
                            _vm.showUsers
                              ? _c("q-list-header", [
                                  _vm._v(_vm._s(_vm.$t("users")))
                                ])
                              : _vm._e(),
                            _vm._l(_vm.users, function(content, index) {
                              return _vm.showMenu(content.meta) && _vm.showUsers
                                ? _c(
                                    "q-item",
                                    {
                                      key: "ru" + index,
                                      attrs: { to: { name: content.to } }
                                    },
                                    [
                                      _c("q-item-side", {
                                        attrs: { icon: content.icon }
                                      }),
                                      _c("q-item-main", {
                                        attrs: { label: _vm.$t(content.text) }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }),
                            _vm.showOrganization
                              ? _c("q-item-separator")
                              : _vm._e(),
                            _vm.showOrganization
                              ? _c("q-list-header", [
                                  _vm._v(_vm._s(_vm.$t("organization")))
                                ])
                              : _vm._e(),
                            _vm._l(_vm.organization, function(content, index) {
                              return _vm.showMenu(content.meta) &&
                                _vm.showOrganization
                                ? _c(
                                    "q-item",
                                    {
                                      key: "ro" + index,
                                      attrs: { to: { name: content.to } }
                                    },
                                    [
                                      _c("q-item-side", {
                                        attrs: { icon: content.icon }
                                      }),
                                      _c("q-item-main", {
                                        attrs: { label: _vm.$t(content.text) }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }),
                            _vm.showTags ? _c("q-item-separator") : _vm._e(),
                            _vm.showTags
                              ? _c("q-list-header", [
                                  _vm._v(_vm._s(_vm.$t("tags")))
                                ])
                              : _vm._e(),
                            _vm._l(_vm.tags, function(content, index) {
                              return _vm.showMenu(content.meta) && _vm.showTags
                                ? _c(
                                    "q-item",
                                    {
                                      key: "tt" + index,
                                      attrs: { to: { name: content.to } }
                                    },
                                    [
                                      _c("q-item-side", {
                                        attrs: { icon: content.icon }
                                      }),
                                      _c("q-item-main", {
                                        attrs: { label: _vm.$t(content.text) }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }),
                            _vm.showImport ? _c("q-item-separator") : _vm._e(),
                            _vm.showImport
                              ? _c("q-list-header", [
                                  _vm._v(_vm._s(_vm.$t("import")))
                                ])
                              : _vm._e(),
                            _vm._l(_vm.importUser, function(content, index) {
                              return _vm.showMenu(content.meta) &&
                                _vm.showImport
                                ? _c(
                                    "q-item",
                                    {
                                      key: "imp" + index,
                                      attrs: { to: { name: content.to } }
                                    },
                                    [
                                      _c("q-item-side", {
                                        attrs: { icon: content.icon }
                                      }),
                                      _c("q-item-main", {
                                        attrs: { label: _vm.$t(content.text) }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showSurveys ||
                _vm.showMessages ||
                _vm.showFaq ||
                _vm.showBanners ||
                _vm.showCalendar
                  ? _c(
                      "q-btn-dropdown",
                      {
                        attrs: {
                          flat: "",
                          dense: "",
                          size: "lg",
                          label: _vm.$t("communications"),
                          color: _vm.getColorComunications()
                        }
                      },
                      [
                        _c(
                          "q-list",
                          { attrs: { link: "" } },
                          [
                            _vm.showSurveys
                              ? _c("q-list-header", [
                                  _vm._v(_vm._s(_vm.$t("surveys")))
                                ])
                              : _vm._e(),
                            _vm._l(_vm.surveys, function(content, index) {
                              return _vm.showMenu(content.meta) &&
                                _vm.showSurveys
                                ? _c(
                                    "q-item",
                                    {
                                      key: "cs" + index,
                                      attrs: { to: { name: content.to } }
                                    },
                                    [
                                      _c("q-item-side", {
                                        attrs: { icon: content.icon }
                                      }),
                                      _c("q-item-main", {
                                        attrs: { label: _vm.$t(content.text) }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }),
                            _vm.showMessages
                              ? _c("q-item-separator")
                              : _vm._e(),
                            _vm.showMessages
                              ? _c("q-list-header", [
                                  _vm._v(_vm._s(_vm.$t("messages")))
                                ])
                              : _vm._e(),
                            _vm._l(_vm.messages, function(content, index) {
                              return _vm.showMenu(content.meta) &&
                                _vm.showMessages
                                ? _c(
                                    "q-item",
                                    {
                                      key: "cm" + index,
                                      attrs: { to: { name: content.to } }
                                    },
                                    [
                                      _c("q-item-side", {
                                        attrs: { icon: content.icon }
                                      }),
                                      _c("q-item-main", {
                                        attrs: { label: _vm.$t(content.text) }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }),
                            _vm.showFaq ? _c("q-item-separator") : _vm._e(),
                            _vm.showFaq
                              ? _c("q-list-header", [
                                  _vm._v(_vm._s(_vm.$t("faq")))
                                ])
                              : _vm._e(),
                            _vm._l(_vm.faq, function(content, index) {
                              return _vm.showMenu(content.meta) && _vm.showFaq
                                ? _c(
                                    "q-item",
                                    {
                                      key: "cf" + index,
                                      attrs: { to: { name: content.to } }
                                    },
                                    [
                                      _c("q-item-side", {
                                        attrs: { icon: content.icon }
                                      }),
                                      _c("q-item-main", {
                                        attrs: { label: _vm.$t(content.text) }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }),
                            _vm.showBanners ? _c("q-item-separator") : _vm._e(),
                            _vm.showBanners
                              ? _c("q-list-header", [
                                  _vm._v(_vm._s(_vm.$t("banners")))
                                ])
                              : _vm._e(),
                            _vm._l(_vm.banners, function(content, index) {
                              return _vm.showMenu(content.meta) &&
                                _vm.showBanners
                                ? _c(
                                    "q-item",
                                    {
                                      key: "cb" + index,
                                      attrs: { to: { name: content.to } }
                                    },
                                    [
                                      _c("q-item-side", {
                                        attrs: { icon: content.icon }
                                      }),
                                      _c("q-item-main", {
                                        attrs: { label: _vm.$t(content.text) }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }),
                            _vm.showBanners ? _c("q-item-separator") : _vm._e(),
                            _vm.showCalendar
                              ? _c("q-list-header", [
                                  _vm._v(_vm._s(_vm.$t("calendar")))
                                ])
                              : _vm._e(),
                            _vm._l(_vm.calendar, function(content, index) {
                              return _vm.showMenu(content.meta) &&
                                _vm.showCalendar
                                ? _c(
                                    "q-item",
                                    {
                                      key: "cc" + index,
                                      attrs: { to: { name: content.to } }
                                    },
                                    [
                                      _c("q-item-side", {
                                        attrs: { icon: content.icon }
                                      }),
                                      _c("q-item-main", {
                                        attrs: { label: _vm.$t(content.text) }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showRewards || _vm.showTablePoints
                  ? _c(
                      "q-btn-dropdown",
                      {
                        attrs: {
                          flat: "",
                          dense: "",
                          size: "lg",
                          label: _vm.$t("rewards"),
                          color: _vm.getColorRewards()
                        }
                      },
                      [
                        _c(
                          "q-list",
                          { attrs: { link: "" } },
                          [
                            _c("q-list-header", [
                              _vm._v(_vm._s(_vm.$t("rewards")))
                            ]),
                            _vm._l(_vm.rewards, function(content, index) {
                              return _vm.showMenu(content.meta)
                                ? _c(
                                    "q-item",
                                    {
                                      key: "rr" + index,
                                      attrs: { to: { name: content.to } }
                                    },
                                    [
                                      _c("q-item-side", {
                                        attrs: { icon: content.icon }
                                      }),
                                      _c("q-item-main", {
                                        attrs: { label: _vm.$t(content.text) }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }),
                            _vm.showTablePoints
                              ? _c("q-item-separator")
                              : _vm._e(),
                            _vm.showTablePoints
                              ? _c("q-list-header", [
                                  _vm._v(_vm._s(_vm.$t("points_table")))
                                ])
                              : _vm._e(),
                            _vm._l(_vm.points_table, function(content, index) {
                              return _vm.showMenu(content.meta) &&
                                _vm.showTablePoints
                                ? _c(
                                    "q-item",
                                    {
                                      key: "tablep" + index,
                                      attrs: { to: { name: content.to } }
                                    },
                                    [
                                      _c("q-item-side", {
                                        attrs: { icon: content.icon }
                                      }),
                                      _c("q-item-main", {
                                        attrs: { label: _vm.$t(content.text) }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.is_superuser
                  ? _c(
                      "q-btn-dropdown",
                      {
                        attrs: {
                          flat: "",
                          dense: "",
                          size: "lg",
                          icon: "fal fa-cog",
                          color: _vm.getColorConfigurations()
                        }
                      },
                      [
                        _c(
                          "q-list",
                          { attrs: { link: "" } },
                          [
                            _c("q-list-header", [
                              _vm._v(_vm._s(_vm.$t("configuration")))
                            ]),
                            _vm._l(_vm.configurations, function(
                              content,
                              index
                            ) {
                              return _c(
                                "q-item",
                                {
                                  key: "cas" + index,
                                  attrs: { to: { name: content.to } }
                                },
                                [
                                  _c("q-item-side", {
                                    attrs: { icon: content.icon }
                                  }),
                                  _c("q-item-main", {
                                    attrs: { label: _vm.$t(content.text) }
                                  })
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }